export default "__VITE_ASSET__Zgf3dCVR__"